import React, { FC, useState, useEffect } from 'react'
import { IonInput, IonModal, IonHeader, IonContent, useIonViewDidEnter } from '@ionic/react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { toast, filterNickname } from '@utils'
import { MktButton } from '@cps'
import './index.scss'

interface IProps {
  resolve?: (val: string) => void;
  reject?: () => void;
}

const EditNickNameModal: FC<IProps> = (props) => {
  const { resolve, reject } = props
  const [nickName, setNickName] = useState('')
  const handleSave = () => {
    if (!nickName) {
      toast({ message: i18n.t('mkt.common.tipNickName') })
      return
    }
    resolve && resolve(nickName)
  }
  useIonViewDidEnter(() => {
    setNickName('')
  })
  return (
    <IonModal
      isOpen
      cssClass='nickname-modify-modal'
    >
      <IonHeader className='modal-header'>
        <i data-cypid='mmgNickNameBack' className='iconfont icon-BACK-12x' onClick={reject}></i>
      </IonHeader>
      <IonContent>
        <div className='modal-content'>
          <div className='title'>{i18n.t('mkt.member.setNickname')}</div>
          <div className='mkt-input'>
            <IonInput data-cypid='mmgNickNameInput' maxlength={20} value={nickName} placeholder={i18n.t('mkt.common.tipNickName')} onIonChange={(e: any) => setNickName(filterNickname(e.detail.value))} />
          </div>
          <div className='btn-area'>
            <MktButton text={i18n.t('mkt.common.save')} disabled={!nickName} onClick={handleSave}></MktButton>
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(EditNickNameModal)
